<template>
    <div class="beneficios">
        <b-container class="mb-5">
            <b-row class="mb-4">
                <b-col>
                    <h3>Acumula beneficios con tu Tarjeta Garlan's</h3>
                </b-col>
            </b-row>
            <b-row>
                <b-col id="c-1" offset-md="3" md="3">
                    <div class="gray-bar"></div>
                    <h4>Garlan's Rewards</h4>
                    <p><span>$1-$499</span><br> Compras Anuales en Garlan's con Garlan's Card</p>
                </b-col>
                <b-col id="c-2" md="3">
                    <div class="gold-bar"></div>
                    <h4>Garlan's Gold Rewards</h4>
                    <p><span>$500-$999</span><br> Compras Anuales en Garlan's con Garlan's Card</p>
                </b-col>
                <b-col id="c-3" md="3">
                    <div class="purple-bar"></div>
                    <h4>Garlan's Premier Rewards</h4>
                    <p><span>$1,000+</span><br> Compras Anuales en Garlan's con Garlan's Card</p>
                </b-col>
                <b-col id="c-4" md="3" class="mb-5">
                    <div class="gray-container fit">
                        <div class="middle-div">
                            <img src="../assets/img/icn_rewards.svg" alt="">
                            <h4>Rewards en tus compras Garlan's</h4>
                        </div>
                    </div>
                </b-col>
                <b-col id="c-5" md="3" class="mb-5">
                    <div class="gray-container">
                        <ul>
                            <li>Garlan's Rewards. Obtén puntos en cada compra.</li>
                            <li>Birthday Cupon. Obtén 20% de descuento en un artículo.</li>
                            <li>Bonus Events. Acumula puntos extras en ciertas marcas.</li>
                            <li>Double Rewards. Puntos al doble en días exclusivos.</li>
                        </ul>
                    </div>
                </b-col>
                <b-col id="c-6" md="3" class="mb-5">
                    <div class="gray-container">
                        <ul>
                            <li>Garlan's Rewards. Obtén puntos en cada compra.</li> 
                            <li>Birthday Cupon. Obtén 20% de descuento en un artículo.</li>
                            <li>Bonus Events. Acumula puntos extras en ciertas marcas.</li> 
                            <li>Double Rewards. Puntos al doble en días exclusivos.</li>
                            <li>Upgrade Status Cupon. Obtén $10.00 dlls al convertirte en cliente Gold o Premier.</li>
                        </ul>
                    </div>
                </b-col>
                <b-col id="c-7" md="3" class="mb-5">
                    <div class="gray-container">
                        <ul>
                            <li>Garlan's Rewards. Obtén puntos en cada compra.</li>
                            <li>Birthday Cupon. Obtén 20% de descuento en un artículo.</li>
                            <li>Bonus Events. Acumula puntos extras en ciertas marcas.</li>
                            <li>Double Rewards. Puntos al doble en días exclusivos.</li>
                            <li>Upgrade Status Cupon. Obtén $10.00 dlls al convertirte en cliente Gold o Premier.</li>
                            <li>Free Shipping. Envíos gratis sin mínimo de compra.</li>
                        </ul>
                    </div>
                </b-col>
            </b-row>
        </b-container>
        <b-container fluid>
            <b-row>
                <b-col>
                    <VueSlickCarousel :arrows="false" :dots="false" v-bind="settings">
                        <div class="slider-gallery"><img class="img-fluid" src="../assets/img/img_gallery1.png" alt=""></div>
                        <div class="slider-gallery"><img class="img-fluid" src="../assets/img/img_gallery2.png" alt=""></div>
                        <div class="slider-gallery"><img class="img-fluid" src="../assets/img/img_gallery3.png" alt=""></div>
                        <div class="slider-gallery"><img class="img-fluid" src="../assets/img/img_gallery4.png" alt=""></div>
                        <div class="slider-gallery"><img class="img-fluid" src="../assets/img/img_gallery5.png" alt=""></div>
                        <div class="slider-gallery"><img class="img-fluid" src="../assets/img/img_gallery6.png" alt=""></div>
                        <div class="slider-gallery"><img class="img-fluid" src="../assets/img/img_gallery7.png" alt=""></div>
                        <div class="slider-gallery"><img class="img-fluid" src="../assets/img/img_gallery8.png" alt=""></div>
                        <div class="slider-gallery"><img class="img-fluid" src="../assets/img/img_gallery9.png" alt=""></div>
                    </VueSlickCarousel>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import VueSlickCarousel from 'vue-slick-carousel'
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    // optional style for arrows & dots
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
    export default {
        components: { VueSlickCarousel },
        data() {
            return {
                settings: {
                    autoplay: true,
                    autoplaySpeed: 7000,
                    focusOnSelect: false,
                    pauseOnFocus: false,
                    pauseOnHover: false,
                    infinite: true,
                    speed: 3000,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    responsive: [
                        {
                            breakpoint: 1008,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                            },
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            },
                        },
                    ],
                }
            }
        },
    }
</script>

<style scoped>
.beneficios{
    padding: 5% 0;
}
.slider-gallery{
    padding: 5px;
}
h3{
    font-family: futura-pt, sans-serif;
    font-size: 50px;
    font-weight: 600;
}
h4{
    font-family: futura-pt, sans-serif;
    font-size: 35px;
    font-weight: 600;
}
p{
    font-weight: 500;
    font-size: 14px;
}

p span{
    font-weight: 500;
    font-size: 16px;
}
.gray-container{
    background-color: #F7F6F7;
    height: 100%;
    padding: 10% 15% 10% 5%;
}
ul{
    font-size: 14px;
}
li{
    margin-bottom: 10px;
}
.purple-bar{
    height: 10px;
    width: 100%;
    background-color: #AF00B1;
    margin-bottom: 20px;
}
.gold-bar{
    height: 10px;
    width: 100%;
    background-color: #F7D85C;
    margin-bottom: 20px;
}
.gray-bar{
    height: 10px;
    width: 100%;
    background-color: #D5D5D5;
    margin-bottom: 20px;
}
.middle-div{
  position: relative;
  padding-left: 10%;
  padding-top: 10%;
  padding-bottom: 10%;
  /* top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%); */
}
.fit{
    height: fit-content;
    height: -moz-fit-content ;
}
@media (max-width: 1600px) {
    h3{
        font-size: 40px;
    }
    h4{
        font-size: 25px;
    }
    ul, p{
        font-size: 11px;
    }

    p span{
        font-size: 13px;
    }
}
@media (max-width: 768px) {
    #c-1{
        order: 2;
    }
    #c-2{
        order: 4;
    }
    #c-3{
        order: 6;
    }
    #c-4{
        order: 1;
    }
    #c-5{
        order: 3;
    }
    #c-6{
        order: 5;
    }
    #c-7{
        order: 7;
    }
    .beneficios{
        padding: 10% 7%;
    }
    h3{
        font-size: 29px;
    }
}
@media (min-width: 1600px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
      max-width: 1550px !important;
  }
}
</style>